<template>
  <div class="agreement_page">
    <div class="agreement_title">{{info.title}}</div>
    <div class="agreement_content" v-html="info.content"></div>
  </div>
  <!-- <div class="web-page">
    <h1>肖像使用协议</h1>
    <div class="content">
          <p>根据《中华人民共和国广告法》以及《中华人民共和国民法典》等相关法律规定，为明确使用方（甲方）和肖像许可方(乙方)的权利义务关系，经双方自愿平等、友好协商，甲乙双方就带有乙方肖像的作品的使用达成如下一致协议：</p>
          <p>肖像许可方(乙方)同意免费使用本人肖像，具体使用范围、方式如下：</p>
          <p>1、使用范围、方式：同意斯巴鲁汽车（中国）有限公司（以下简称斯巴鲁）在下述范围内无偿使用本人肖像：</p>
          <p>（1）举办或参加的各类公开或非公开活动展示；</p>
          <p>（2）举办的公开或非公开出售的期刊、杂志以及网站展示；</p>
          <p>（3）宣传资料，包括但不限于宣传海报、视频以及在媒体（包括但不限于电视、广播、平面媒体、店头宣传品、户外媒体、互联网、公众号、视频平台等）上投放的广告、软文等；</p>
          <p>2、使用地域范围：适用地域范围包括国内和国外。</p>
          <p>3、斯巴鲁有权对用户的肖像进行拍摄，并对拍摄后的图片或乙方自行提供的肖像图片进行制作加工，包括裁剪、缩放、色彩调整、细节美化或其他保留图片人物面部特征，且不损害人物形象的技术处理。</p>
          <p>4、斯巴鲁为履行本协议之目的，拍摄的包含用户肖像在内的图片或其他影视资料的著作权由斯巴鲁方享有。</p>
          <p>5、斯巴鲁不得以对用户人格尊严造成损害或给用户带来不利影响的方式使用用户肖像图片。</p>
          <p>6、斯巴鲁以违反本协议约定的方式使用用户肖像图片时，用户有权要求斯巴鲁停止使用行为；给用户造成不利影响的，斯巴鲁方应采取有效措施消除该不利影响。</p>
          <p>7、斯巴鲁方有权将其拍摄的用户肖像图片向斯巴鲁企业以外的其他方公开使用、转授权他人使用。</p>
          <p>8、肖像权使用期限：乙方同意甲方进行永久使用。</p>
          <p>9、因本协议而引起的或与本协议有关的任何争议，双方应友好协商解决。如协商不成，则应向北京仲裁委员会申请仲裁。仲裁是终局的，对双方均具约束力。</p>
        </div>
      </div> -->

    </template>

    <script>
      import content from '../../api/content';
      export default {
        data () {
          return {
            name: '富士范儿',
            info:''
          }
        },
        created () {
          this.$store.commit('param/show', false)
          this.$appService.isShowReturn({state: true})
          this.getAgreement(4)
        },
        methods: {
          getAgreement(id){
            content.getAgreement({id:id}).then(res => {
              this.info=res.data.data
            })
          },
        }
      };
    </script>

    <style lang="scss">
      .agreement_page {
        padding: 10px;
      }
    </style>
